import React, { useState, useRef, useEffect } from 'react';
import { keyRoot, normalizeKey } from '../utils/normalize';

export default function KeyInput({ value, onChange, suggestions = [], inputStyle, textStyle }) {
  const [filtered, setFiltered] = useState([]);
  const [show, setShow] = useState(false);
  const [activated, setActivated] = useState(false);
  const ref = useRef();

  const normalizeForMatch = str =>
    (str || '').toLowerCase().replace(/\s+/g, '');

  const filterSuggestions = (input) => {
    const inputNorm = normalizeForMatch(input);
    const inputRoot = keyRoot(input).toUpperCase(); // Normalize root to uppercase

    return suggestions.filter(s => {
      const sRoot = keyRoot(s).toUpperCase();
      return sRoot === inputRoot;
    });
  };

  const handleInputChange = (e) => {
    onChange(e); // Filtering will happen in useEffect
  };

  useEffect(() => {
    if (!activated) return;

    const normInput = normalizeForMatch(value);
    const rootMatch = normInput.match(/^(c#|cb|c|d#|db|d|e#|eb|e|f#|fb|f|g#|gb|g|a#|ab|a|b#|bb|b)/i);
    if (!rootMatch) {
      setFiltered([]);
      setShow(false);
      return;
    }

    const matches = suggestions.filter(s =>
      normalizeForMatch(s).startsWith(normInput)
    );

    setFiltered(matches);
    setShow(matches.length > 0);
  }, [value, suggestions, activated]);

  return (
<div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column' }}>

  <input
    ref={ref}
    name="key"
    placeholder="Key"
    autoComplete="off"
    value={value}
    style={{ ...inputStyle, width: '100%', boxSizing: 'border-box' }}
    onChange={handleInputChange}
    onFocus={() => {
      setActivated(true);
      const val = value || '';
      const normInput = normalizeForMatch(val);
      const rootMatch = normInput.match(/^(c#|cb|c|d#|db|d|e#|eb|e|f#|fb|f|g#|gb|g|a#|ab|a|b#|bb|b)/i);

      if (!rootMatch) {
        setFiltered([]);
        setShow(false);
        return;
      }

      const matches = suggestions.filter(s =>
        normalizeForMatch(s).startsWith(normInput)
      );

      setFiltered(matches);
      setTimeout(() => setShow(matches.length > 0), 0);
    }}
    onBlur={() => setTimeout(() => setShow(false), 100)}
  />




      {show && (
        <ul style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: 'var(--input-bg)',
          border: '1px solid var(--card-border)',
          borderTop: 'none',
          maxHeight: '150px',
          overflowY: 'auto',
          margin: 0,
          padding: 0,
          listStyle: 'none',
          zIndex: 2,
        }}>
          {filtered.map((s, i) => (
            <li
              key={i}
              onMouseDown={() => {
                if (s !== value) {
                  onChange({ target: { name: 'key', value: s } });
                }
                setShow(false);
                setFiltered([]);
                setTimeout(() => ref.current?.blur(), 50);
              }}
              style={{
                padding: '6px 8px',
                cursor: 'pointer',
                backgroundColor: 'var(--input-bg)',
                color: 'var(--input-text)'
              }}
            >
              {s}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
